import Route from '@ember/routing/route';

export default class TrainingRoute extends Route {}
